import styled from 'styled-components';

export const GeneralTitle = styled.h1 `
  font-size: ${(props) => (props.xs || props.sm ? '1.5rem' : '2rem')};
  font-weight: 700;
  line-height: ${(props) => (props.xs || props.sm ? '1.7rem' : '2.5rem')};
  /* margin: 0 0 .5rem 0; */
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : '.5rem'};
`;
